import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";
// import { pageSize } from "../helpers";

const masterDataUrlMapping = {
  drmCountryData: URLS.DRM_COUNTRY_LIST,
  drmCarrierData: URLS.DRM_CARRIER_LIST,
  drmServiceData: URLS.DRM_SERVICE_LIST,
  drmStateData: URLS.DRM_STATE_LIST,
  drmDivisionData: URLS.DRM_DIVISION_LIST,
  drmZoneData: URLS.DRM_ZONE_LIST,
  drmTransportData: URLS.DRM_TRANSPORT_LIST,
  drmEquipmentData: URLS.DRM_EQUIPMENT_LIST,
  drmChargesData: URLS.DRM_CHARGES_LIST,
  drmTariffIdsData: URLS.DRM_TARIFF_DATA,
  drmZoneShortDescData: URLS.DRM_ZONE_SHORT_DESC_LIST,
  drmZoneLongDescData: URLS.DRM_ZONE_LONG_DESC_LIST,
  drmTariffEquipMappingData: URLS.DRM_TARIFF_EQUIP_TYPE_MAPPING,
};

export const fetchDrmMasterData = async ([key, body, onPage, controller]) => {
  try {
    const pageSize = 500;
    const response = await axios.post(
      `${masterDataUrlMapping[key]}?pageNum=${onPage}&pageSize=${pageSize}`,
      body, 
      { signal: controller?.signal }
    );
    return response.data; 
  } catch (error) {
    throw error.response?.data || error;
  }
};
